__turbopack_context__.v({
  "auctions": "ScrollableItem-module-scss-module__E-ffxq__auctions",
  "item": "ScrollableItem-module-scss-module__E-ffxq__item",
});
